import { TableHead, TableRow } from "@material-ui/core";
import { ResponsiveTableCell } from "../../../../components/layout/responsive-table/responsive-table-cell.component";
import React from "react";
import { ProductsTableHeaderProps } from "./products-table-header.props";

export const ProductsTableHeader = (props: ProductsTableHeaderProps) => (
  <TableHead>
    <TableRow>
      <ResponsiveTableCell className="wide pad-left">Item #</ResponsiveTableCell>
      <ResponsiveTableCell />
      <ResponsiveTableCell className="wide pad-left">Item Code</ResponsiveTableCell>
      <ResponsiveTableCell align="left">Item Desc.</ResponsiveTableCell>
      <ResponsiveTableCell align="left">SubClass</ResponsiveTableCell>
      <ResponsiveTableCell showIf={props.showBuyGet} align="left">
        Is Buy/Get?
      </ResponsiveTableCell>
      <ResponsiveTableCell showIf={props.showBuyGet} align="left">
        Get Products
      </ResponsiveTableCell>
      <ResponsiveTableCell showIf={props.isEdm} align="left">
        Position
      </ResponsiveTableCell>
      <ResponsiveTableCell align="left">Reg. Price</ResponsiveTableCell>
      <ResponsiveTableCell align="left">Promo&nbsp;Price</ResponsiveTableCell>
      <ResponsiveTableCell align="left">Savings Badge</ResponsiveTableCell>
      <ResponsiveTableCell align="right" />
    </TableRow>
  </TableHead>
);
